module.exports = "/build/admin/images/favicon-16x16.23b6b685.png";